import React, { useState, useEffect } from "react";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from "recharts";
import "./RelatorioView.css";

export default function RelatorioView() {
  const [dados, setDados] = useState([]);
  const [resumo, setResumo] = useState([]);
  const [filtroData, setFiltroData] = useState("");

  // Busca os dados no backend
  useEffect(() => {
  carregarDados();
}, [filtroData]);

async function carregarDados() {
  try {
    const url = filtroData
      ? `https://gerencial.vionia.com.br/api/relatorio/beneficiarios?data_inicio=${filtroData}`
      : `https://gerencial.vionia.com.br/api/relatorio/beneficiarios`;

    const res = await fetch(url);
    const json = await res.json();

    // Se o backend retornar { grafico, detalhes }
    const lista = Array.isArray(json) ? json : (json.detalhes || []);

    setDados(lista);

    // Gera o resumo para o gráfico
    const resumoEstagio = {};
    lista.forEach((item) => {
      resumoEstagio[item.estagio] = (resumoEstagio[item.estagio] || 0) + 1;
    });
    const resumoArray = Object.entries(resumoEstagio).map(([estagio, total]) => ({
      estagio,
      total
    }));
    setResumo(resumoArray);

  } catch (err) {
    console.error("Erro ao carregar relatório:", err);
  }
}


  return (
    <div className="relatorio-container">
      <h2>📊 Relatório de Beneficiários</h2>

      {/* Filtro */}
      <div className="filtro-container">
        <label>Filtrar por Data de Início:</label>
        <input
          type="date"
          value={filtroData}
          onChange={(e) => setFiltroData(e.target.value)}
        />
        <button onClick={() => setFiltroData("")}>Limpar</button>
      </div>

      {/* Gráfico */}
      <div className="grafico-container">
        <h3>Beneficiários por Estágio</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={resumo}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="estagio" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Bar dataKey="total" fill="#00a99d" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Tabela */}
      <div className="tabela-container">
        <h3>Detalhes</h3>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome</th>
              <th>Produto</th>
              <th>Estágio</th>
              <th>Data Início</th>
            </tr>
          </thead>
          <tbody>
            {dados.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.nome}</td>
                <td>{item.produto_id}</td>
                <td>{item.estagio}</td>
                <td>{item.data_inicio}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
